export enum CommonGenericEvents {
	ClickHeader = 'click_header',
}

export enum SectionParameters {
	Favorites = 'favorites',
}
